export const environment = {
  production: true,
  baseApiUrl: 'https://api-demo.roto-versal.com/',
  baseAppUrl: 'https://app-demo.roto-versal.com/',
  env: 'demo'
};
